import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../../hooks/auth";
import { useCallback, useEffect, useRef, useState } from "react";
import MountIcons from "../../../../shared/utils/MountIcons";
import PagesButton from "../../../../shared/components/PageButton";
import UxDocLogoComponent from "../../../../shared/components/UxDocLogo";
import { ComponentAvatar } from "../../../../shared/components/Avatar/styles";
import ScreenHome from "../../../home/ScreenHome";
import ScreenCreateNewProject from "../../../createproject/screen";
import MyProjects from "../../../myprojects/screen";
import MyClausules from "../../../myclausules/screen";
import LetterAvatar from "../../components/LetterAvatar";

import SharedIcon from "../../assets/shared-icon-dpath.svg";
import MultiplesAvatarLetter from "../../components/MultiplesAvatarLetter";
import DropdownAvatar from "../../../editor/components/DropdownAvatar";
import DropdownAvatarDash from "../../../editor/components/DropdownAvatarDash";
import { useMainHook } from "../../../../hooks/main";
import SharedWithMe from "../../../sharedwithme";
import { getColors } from "../../../editor/utils/getColorAvatar";
import { ComponentToPrint } from "../../components/AvatarPrintComponent";
import {
  exportComponentAsJPEG,
  exportComponentAsPDF,
  exportComponentAsPNG
} from "react-component-export-image";
import html2canvas from "html2canvas";
import api from "../../../../services/api";
import LoadingEditor from "../../../editor/components/LoadingEditor";
import PuffLoader from "react-spinners/PuffLoader";
import MyAutomations from "../../../myAutomations/screen";
import iconAutomation from "../../../../shared/assets/icon-automation.svg";

import {
  Aside,
  AsideFooter,
  AsideGap,
  AsideMain,
  AsideTop,
  CentralBoxHeader,
  CentralBoxMain,
  Container,
  Header,
  LabelVersion,
  Main,
  TextAvatar,
  TextVersion,
  TopLine
} from "./styles";

const Master: React.FC = () => {
  const { signOut } = useAuth();
  const navigate: any = useNavigate();
  const [screen, setScreen] = useState<
    | "Home"
    | "CreateNewProject"
    | "MyProjects"
    | "MyClausules"
    | "MySharedDocuments"
    | "MyAutomations"
  >("Home");
  const [activeButton, setActiveButton] = useState("");
  const [activeButtonClcik, setActiveButtonClick] = useState("");
  const [letters, setLetters] = useState("LUCAS JUSTE");
  const [color, setColor] = useState("");
  const [isOpenAvatarConfig, setIsOpenAvatarConfig] = useState(false);
  const [loadingAvatar, setLoadingAvatar] = useState(false);
  const {
    srcAvatar,
    setSrcAvatar,
    refreshAvatar,
    setRefreshAvatar,
    profile,
    isModalCreateClause,
    setIsModalCreateClause
  } = useMainHook();

  const [avatarChange, setAvatarChange] = useState("");

  const generateColor = useCallback(() => {
    let randomColor = getColors();
    setColor(randomColor);
  }, []);

  const { data, permissionType, setPermissionType } = useAuth();

  const moveToURL = (url: string) => {
    navigate(url);
  };

  useEffect(() => {
    setLetters(`${data.people.first_name} ${data.people.last_name}`);
    generateColor();
  }, []);

  const refAvatar = useRef(null);

  //useEffect for save avatar image
  useEffect(() => {
    let myImage: any;

    const autoLoadingAvatar = async () => {
      if (srcAvatar.includes("avatar_default")) {
        html2canvas(document.querySelector("#capture")).then(canvas => {
          myImage = canvas.toDataURL();
          if (myImage) {
            setAvatarChange(state => (state = myImage));
          }
        });
      }
    };

    if (profile) {
      setTimeout(() => {
        autoLoadingAvatar();
      }, 1000);
    }
  }, [profile]);

  useEffect(() => {
    const autoSaveAvatar = async () => {
      if (avatarChange) {
        setLoadingAvatar(true);
        const blob = await (await fetch(avatarChange)).blob();
        const file = new File([blob], "fileName.png", {
          type: "image/png"
        });

        let formData = new FormData();
        formData.append("avatar", file);

        try {
          const requestAvatarChange = await api.patch(
            "users/avatar",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data"
              }
            }
          );
          setLoadingAvatar(false);
          setRefreshAvatar(!refreshAvatar);
        } catch (err) {
          console.log(
            err,
            "ERROR WHEN UPDATE AVATAR IMAGE IF NOT EXISTS AVATAR"
          );
          setLoadingAvatar(false);
        }
      } else {
        setLoadingAvatar(false);
      }
    };

    autoSaveAvatar();
  }, [avatarChange]);

  //fixing issue with z-index modal and photo
  //and both of the components conflicts z-indez
  const [zIndexActive, setZIndexActive] = useState(false);

  useEffect(() => {
    if (isModalCreateClause) {
      setZIndexActive(true);
    } else {
      setZIndexActive(false);
    }
  }, [isModalCreateClause]);

  useEffect(() => {
    setScreen("MyProjects");
    setActiveButtonClick("MyProjects");
  }, []);

  return (
    <Container ref={refAvatar}>
      <Header>
        <CentralBoxHeader>
          <div style={{ marginLeft: "auto" }}>
            <DropdownAvatarDash
              isOpen={isOpenAvatarConfig}
              setIsOpen={setIsOpenAvatarConfig}
              color={getColors()}
              zIndexActive={zIndexActive}
            >
              {loadingAvatar && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                    marginRight: "2rem"
                  }}
                  className="loading-container"
                >
                  <PuffLoader color="#000" size="28" />
                </div>
              )}

              <MultiplesAvatarLetter
                className="avatar-dashboard"
                src={String(srcAvatar)}
                text={letters}
                setText={setLetters}
                color={color}
                idElement={"capture"}
              />
            </DropdownAvatarDash>
          </div>
          <TopLine />
        </CentralBoxHeader>
      </Header>
      <Aside>
        <AsideGap></AsideGap>
        <AsideTop>
          <UxDocLogoComponent />
        </AsideTop>
        <AsideMain>
          {/* <PagesButton
            onClick={() => {
              setScreen("Home");
              setActiveButtonClick("Home");
            }}
            onMouseEnter={() => {
              setActiveButton("Home");
            }}
            onMouseOut={() => {
              setActiveButton("");
            }}
            onMouseLeave={() => {}}
            isActive={activeButton === "Home" ? true : false}
            isActiveClick={activeButtonClcik === "Home" ? true : false}
            buttonLabel="Home"
            dPath={MountIcons.HomeIcon.dPath}
            viewBox={MountIcons.HomeIcon.viewBox}
            iconWidth={33}
            iconHeight={33}
            classNameIcon="icon"
          /> */}

          <PagesButton
            onClick={() => {
              if (permissionType === "normal" || "editor") {
                setScreen("MyProjects");
                setActiveButtonClick("MyProjects");
              }
            }}
            onMouseEnter={() => {
              setActiveButton("MyProjects");
            }}
            onMouseOut={() => {
              setActiveButton("");
            }}
            onMouseLeave={() => {}}
            isActive={activeButton === "MyProjects" ? true : false}
            isActiveClick={activeButtonClcik === "MyProjects" ? true : false}
            buttonLabel="Meus projetos"
            dPath={MountIcons.MyProjectsIcon.dPath}
            viewBox={MountIcons.MyProjectsIcon.viewBox}
            iconWidth={33}
            iconHeight={33}
            classNameIcon="icon"
          />

          <PagesButton
            onClick={() => {
              if (permissionType === "normal") {
                setScreen("CreateNewProject");
                setActiveButtonClick("CreateNewProject");
              }
            }}
            style={
              permissionType === "editor"
                ? {
                    cursor: "not-allowed",
                    opacity: "0.6"
                  }
                : {}
            }
            onMouseEnter={() => {
              setActiveButton("CreateNewProject");
            }}
            onMouseOut={() => {
              setActiveButton("");
            }}
            onMouseLeave={() => {}}
            isActive={activeButton === "CreateNewProject" ? true : false}
            isActiveClick={
              activeButtonClcik === "CreateNewProject" ? true : false
            }
            buttonLabel="Criar novo projeto"
            dPath={MountIcons.NewProjectIcon.dPath}
            viewBox={MountIcons.NewProjectIcon.viewBox}
            iconWidth={33}
            iconHeight={33}
            classNameIcon="icon"
          />

          <PagesButton
            onClick={() => {
              if (permissionType === "normal") {
                setScreen("MyClausules");
                setActiveButtonClick("MyClausules");
              }
            }}
            style={
              permissionType === "editor"
                ? {
                    cursor: "not-allowed",
                    opacity: "0.6"
                  }
                : {}
            }
            onMouseEnter={() => {
              setActiveButton("MyClausules");
            }}
            onMouseOut={() => {
              setActiveButton("");
            }}
            onMouseLeave={() => {}}
            isActive={activeButton === "MyClausules" ? true : false}
            isActiveClick={activeButtonClcik === "MyClausules" ? true : false}
            buttonLabel="Minha biblioteca"
            dPath={MountIcons.IconLibrary.dPath}
            viewBox={MountIcons.IconLibrary.viewBox}
            iconWidth={33}
            iconHeight={33}
            classNameIcon="icon"
          />

          <PagesButton
            onClick={() => {
              if (permissionType === "normal") {
                setScreen("MySharedDocuments");
                setActiveButtonClick("MySharedDocuments");
              }
            }}
            style={
              permissionType === "editor"
                ? {
                    cursor: "not-allowed",
                    opacity: 0.6
                  }
                : {}
            }
            onMouseEnter={() => {
              setActiveButton("MySharedDocuments");
            }}
            onMouseOut={() => {
              setActiveButton("");
            }}
            onMouseLeave={() => {}}
            isActive={activeButton === "MySharedDocuments" ? true : false}
            isActiveClick={
              activeButtonClcik === "MySharedDocuments" ? true : false
            }
            buttonLabel="Compartilhados comigo"
            dPath={MountIcons.IconShared.dPath}
            viewBox={MountIcons.IconShared.viewBox}
            iconWidth={33}
            iconHeight={33}
            classNameIcon="icon"
          />

          <PagesButton
            onClick={() => {
              if (permissionType === "normal") {
                setScreen("MyAutomations");
                setActiveButtonClick("MyAutomations");
              }
            }}
            style={
              permissionType === "editor"
                ? {
                    cursor: "not-allowed",
                    opacity: 0.6
                  }
                : {}
            }
            onMouseEnter={() => {
              setActiveButton("MyAutomations");
            }}
            onMouseOut={() => {
              setActiveButton("");
            }}
            onMouseLeave={() => {}}
            isActive={activeButton === "MyAutomations" ? true : false}
            isActiveClick={activeButtonClcik === "MyAutomations" ? true : false}
            buttonLabel="Versões automatizadas"
            dPath={MountIcons.IconAutomation.dPath}
            viewBox={MountIcons.IconAutomation.viewBox}
            iconWidth={33}
            iconHeight={33}
            classNameIcon="icon"
          />
        </AsideMain>
        <AsideFooter>
          <PagesButton
            onClick={() => {
              if (permissionType === "editor") return;
              window.open(
                `https://legaldesignbits.com/uxdoc-legaldesignpass/?utm_source=botao&utm_medium=uxdoc&utm_campaign=novomembro`,
                "_blank"
              );
            }}
            onMouseEnter={() => {
              if (permissionType === "normal") {
                setActiveButton("courses");
              }
            }}
            onMouseOut={() => {
              setActiveButton("");
            }}
            style={
              permissionType === "editor"
                ? {
                    cursor: "not-allowed",
                    opacity: 0.6
                  }
                : {}
            }
            onMouseLeave={() => {}}
            isActive={activeButton === "courses" ? true : false}
            buttonLabel="Cursos"
            dPath={MountIcons.IconCourses.dPath}
            viewBox={MountIcons.IconCourses.viewBox}
            iconWidth={33}
            iconHeight={33}
            classNameIcon="icon"
          />
          <PagesButton
            onClick={() => {
              signOut();
            }}
            onMouseEnter={() => {
              setActiveButton("Logout");
            }}
            onMouseOut={() => {
              setActiveButton("");
            }}
            onMouseLeave={() => {}}
            isActive={activeButton === "Logout" ? true : false}
            buttonLabel="Sair"
            dPath={MountIcons.ExitIcon.dPath}
            viewBox={MountIcons.ExitIcon.viewBox}
            iconWidth={33}
            iconHeight={33}
            classNameIcon="icon"
          />
          <LabelVersion>
            <TextVersion>Versão 0.1.8</TextVersion>
          </LabelVersion>
        </AsideFooter>
      </Aside>
      <Main>
        {/*INTIAL MAIN CONTENT 2*/}
        <CentralBoxMain>
          {screen === "Home" && <ScreenHome />}
          {screen === "CreateNewProject" && <ScreenCreateNewProject />}
          {screen === "MyProjects" && <MyProjects />}
          {screen === "MyClausules" && <MyClausules />}
          {screen === "MySharedDocuments" && <SharedWithMe />}
          {screen === "MyAutomations" && <MyAutomations />}
        </CentralBoxMain>
        {/*END MAIN CONTENT*/}
      </Main>
    </Container>
  );
};

export default Master;
